import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import '@maersk-global/mds-components-core/mc-modal';
import '@maersk-global/mds-components-core/mc-button';
import '@maersk-global/mds-components-core/mc-radio-group';
import '@maersk-global/mds-components-core/mc-radio';

export const SALES_RESTRICTION_OVERRIDE_REASONS = ['My stack is full', 'I am in deficit', 'Declare container as TTL'] as const;
export type SalesRestrictionOverrideReason = (typeof SALES_RESTRICTION_OVERRIDE_REASONS)[number];

@Component({
  selector: 'app-sales-restriction-override-modal',
  standalone: true,
  imports: [],
  templateUrl: './sales-restriction-override-modal.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SalesRestrictionOverrideModalComponent implements OnChanges {
  @Input() open = false;
  @Input() equipmentNumber = '';
  @Input() shopLocationCode = '';

  @Output() confirmed = new EventEmitter<string>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  readonly reasons = SALES_RESTRICTION_OVERRIDE_REASONS;
  selectedReason: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    const openChange = changes['open'];
    if (openChange?.currentValue && !openChange.previousValue) {
      this.resetForm();
    }
  }

  private resetForm(): void {
    this.selectedReason = null;
  }

  onReasonChange(event: Event): void {
    const detail = (event as CustomEvent).detail;
    const value = detail?.value ?? (event.target as HTMLInputElement)?.value ?? null;
    this.selectedReason = typeof value === 'string' && value.length > 0 ? value : null;
  }

  onConfirm(): void {
    if (this.selectedReason) {
      this.confirmed.emit(this.selectedReason);
      this.selectedReason = null;
    }
  }

  onCancel(): void {
    this.selectedReason = null;
    this.cancelled.emit();
  }

  onClosed(): void {
    this.selectedReason = null;
    this.closed.emit();
  }
}
